/**
 *  For mapping values from a form that are not a form element
 *    e.g. 'Submitter's First Name' or 'Date of Submission'
 */
export enum SubmissionInformationType {
  SubmittersFirstName = 1,
  SubmittersLastName = 2,
  SubmittersEmail = 3,
  DateOfSubmission = 4,
  MappingQueuedDate= 5,
  WorkflowStepCompletion = 6,
  WorkflowStepStart = 7,
  SubmissionID = 8,
}

export const SubmissionInformationTypeDisplay: {[key in SubmissionInformationType]: {label: string, type: string}} = {
  [SubmissionInformationType.SubmittersFirstName] : { label: "Submitter's First Name", type: 'string (readonly)' },
  [SubmissionInformationType.SubmittersLastName]: { label: "Submitter's Last Name", type: 'string (readonly)' },
  [SubmissionInformationType.SubmittersEmail]: { label: "Submitter's Email", type: 'string (readonly)' },
  [SubmissionInformationType.DateOfSubmission]: { label: "Date of Submission", type: 'date (readonly)' },
  [SubmissionInformationType.MappingQueuedDate]: { label: "Mapping Queued Date", type: 'date (readonly)' },
  [SubmissionInformationType.WorkflowStepCompletion]: { label: "Workflow Step Completion", type: 'date (readonly)' },
  [SubmissionInformationType.WorkflowStepStart]: { label: "Workflow Step Start", type: 'date (readonly)' },
  [SubmissionInformationType.SubmissionID]: { label: "Submission ID", type: 'string (readonly)'},
}